import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthState } from '@app/core/auth/states/auth.state';
import { planNames } from '@app/features/app-content/states/app-configuration.state';
import { Store } from '@ngxs/store';
import { filter, map, Observable } from 'rxjs';
import { PublishingState } from '../../states/publishing.state';

@Component({
  selector: 'rk-publishing-header-admin-view',
  imports: [AsyncPipe],

  templateUrl: './publishing-header-admin-view.component.html',
  styleUrl: './publishing-header-admin-view.component.scss',
})
export class PublishingHeaderAdminViewComponent {
  planId$: Observable<number> = inject(Store).select(PublishingState.planId);
  isAdmin$: Observable<boolean> = inject(Store).select(AuthState.isAdminOrSuperuser);

  getPlanIdName(): Observable<string> {
    return this.planId$.pipe(
      filter(id => !!id),
      map(planId => planNames.find(plan => plan.id === planId)?.name),
    );
  }
}
